// Configuração e instâncias do Firebase (app, Firestore, Auth) + caminhos base
import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Feature flag — set to true to re-enable offline flows
export const OFFLINE_MODE_ENABLED: boolean = (process.env.REACT_APP_OFFLINE_MODE === '1') || false;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!,
};

export const firebaseApp = initializeApp(firebaseConfig);

// ── App Check (reCAPTCHA v3) — DESATIVADO em 2026-06-11 ─────────────────────
// Motivo: a aquisicao do token reCAPTCHA passou a travar/falhar de forma
// intermitente (provavel cota mensal excedida), pendurando o login da docente
// ("Entrando..." -> "Falha no login") e causando instabilidade nos alunos.
// O enforcement foi cancelado no Firebase Console (Authentication e Firestore).
// Para reativar no futuro: restaurar o bloco initializeAppCheck + reativar
// enforcement no Console. Seguranca remanescente: Firestore Rules + PBKDF2.

export const db = (() => {
  try { return initializeFirestore(firebaseApp, { localCache: persistentLocalCache() }); }
  catch(e) { return getFirestore(firebaseApp); }
})();
export const auth = getAuth(firebaseApp);

export const ROOT = "artifacts/geo-frequencia-2026/public/data";
export function periodBase(pid: string) { return ROOT + "/periodos/" + pid; }
export const PERIODS_COL = ROOT + "/periodos_meta";
